/* ============================================
   LUXURY FASHION THEME - JavaScript
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // Mobile Menu
  // ============================================
  const mobileMenu = {
    init() {
      const toggleBtn = document.querySelector('[data-menu-toggle]');
      const closeBtn = document.querySelector('[data-menu-close]');
      const menu = document.querySelector('[data-mobile-menu]');

      if (!toggleBtn || !menu) return;

      toggleBtn.addEventListener('click', () => {
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    }
  };

  // ============================================
  // Search Overlay
  // ============================================
  const searchOverlay = {
    init() {
      const toggleBtn = document.querySelector('[data-search-toggle]');
      const closeBtn = document.querySelector('[data-search-close]');
      const overlay = document.querySelector('[data-search-overlay]');
      const input = document.querySelector('[data-search-input]');

      if (!toggleBtn || !overlay) return;

      toggleBtn.addEventListener('click', () => {
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (input) setTimeout(() => input.focus(), 300);
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          overlay.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    }
  };

  // ============================================
  // Cart Drawer
  // ============================================
  const cartDrawer = {
    init() {
      const openBtns = document.querySelectorAll('[data-cart-toggle]');
      const closeBtn = document.querySelector('[data-cart-close]');
      const drawer = document.querySelector('[data-cart-drawer]');
      const overlay = document.querySelector('[data-cart-overlay]');

      if (!drawer) return;

      openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }

      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }
    },

    open() {
      const drawer = document.querySelector('[data-cart-drawer]');
      const overlay = document.querySelector('[data-cart-overlay]');
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      const drawer = document.querySelector('[data-cart-drawer]');
      const overlay = document.querySelector('[data-cart-overlay]');
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  // ============================================
  // Header Scroll Behavior
  // ============================================
  const headerScroll = {
    init() {
      const header = document.querySelector('[data-header]');
      if (!header) return;

      let lastScroll = 0;
      const threshold = 100;

      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > threshold && currentScroll > lastScroll) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }

        lastScroll = currentScroll;
      }, { passive: true });
    }
  };

  // ============================================
  // Product Accordions
  // ============================================
  const productAccordions = {
    init() {
      const accordions = document.querySelectorAll('[data-accordion]');

      accordions.forEach(accordion => {
        const header = accordion.querySelector('[data-accordion-header]');
        if (!header) return;

        header.addEventListener('click', () => {
          accordion.classList.toggle('is-open');
        });
      });
    }
  };

  // ============================================
  // Product Variant Selector
  // ============================================
  const variantSelector = {
    init() {
      const options = document.querySelectorAll('[data-variant-option]');

      options.forEach(option => {
        // product-template.liquid already controls these options on product
        // pages, including the selected image, price, preorder and availability.
        // A second handler in theme.js can overwrite the correct variant state.
        if (option.closest('.product-page')) return;
        option.addEventListener('click', () => {
          const group = option.closest('[data-variant-group]');
          if (!group) return;

          group.querySelectorAll('[data-variant-option]').forEach(opt => {
            opt.classList.remove('is-active');
          });
          option.classList.add('is-active');

          // Update hidden variant input
          this.updateVariant();
        });
      });
    },

    updateVariant() {
      const activeOptions = document.querySelectorAll('[data-variant-option].is-active');
      const variantInput = document.querySelector('[data-variant-id]');
      if (!variantInput) return;

      // Build variant string from active options
      const values = [];
      activeOptions.forEach(opt => values.push(opt.dataset.value));

      // Find matching variant
      const variantsJson = document.querySelector('[data-product-variants]');
      if (!variantsJson) return;

      try {
        const variants = JSON.parse(variantsJson.textContent);
        const match = variants.find(v => {
          return v.options.every((opt, i) => opt === values[i]);
        });

        if (match) {
          variantInput.value = match.id;
          // Update price display
          const priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            priceEl.textContent = this.formatMoney(match.price);
          }
        }
      } catch (e) {
        console.error('Error parsing variants:', e);
      }
    },

    formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };

  // Add-to-cart is handled by the single AJAX handler below.
  // Do not register another submit handler here: that caused double additions.

  // ============================================
  // Scroll Animations
  // ============================================
  const scrollAnimations = {
    init() {
      const elements = document.querySelectorAll('[data-animate]');
      if (!elements.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      elements.forEach(el => observer.observe(el));
    }
  };

  // ============================================
  // Initialize
  // ============================================
  document.addEventListener('DOMContentLoaded', () => {
    mobileMenu.init();
    searchOverlay.init();
    cartDrawer.init();
    headerScroll.init();
    productAccordions.init();
    variantSelector.init();
    scrollAnimations.init();
  });

})();
(function () {
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = '';
    });

    const drawerTitle = document.querySelector('.cart-drawer__title');
    if (drawerTitle) {
      drawerTitle.textContent = `Your Bag (${cart.item_count})`;
    }
  }

  function updateCartDrawerItems(cart) {
    const content = document.querySelector('[data-cart-drawer-content]');
    if (!content) return;

    if (cart.item_count === 0) {
      content.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      return;
    }

    content.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" class="cart-item__image">`
        : '';

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>`
        : '';

      return `
        <div class="cart-item">
          ${image}

          <div class="cart-item__info">
            <p class="cart-item__title">${escapeHtml(item.product_title)}</p>
            ${variant}
            <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
            <a href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=0" class="cart-item__remove">Remove</a>
          </div>
        </div>
      `;
    }).join('');
  }

  function updateCartDrawerFooter(cart) {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    let footer = document.querySelector('[data-cart-drawer-footer]');

    if (cart.item_count === 0) {
      if (footer) footer.remove();
      return;
    }

    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-drawer__footer';
      footer.setAttribute('data-cart-drawer-footer', '');
      drawer.appendChild(footer);
    }

    footer.innerHTML = `
      <div class="cart-drawer__subtotal">
        <span>Subtotal</span>
        <span>${formatMoney(cart.total_price)}</span>
      </div>

      <a href="/checkout" class="cart-drawer__checkout">PROCEED TO CHECKOUT</a>
    `;
  }

  function openCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');

    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');

    document.body.style.overflow = 'hidden';
  }

  function initAjaxAddToCart() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach((form) => {
      if (form.dataset.ajaxCartReady === 'true') return;
      form.dataset.ajaxCartReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        // A blank-SKU option is now a Notify Me request, never an item for cart.
        // Product template handles opening the separate contact form.
        if (form.dataset.notifyActive === 'true') {
          const trigger = form.querySelector('[data-notify-trigger]');
          if (trigger) trigger.click();
          return;
        }

        // One network request per submit, even if the customer clicks twice.
        if (form.dataset.cartSubmitting === 'true') return;
        form.dataset.cartSubmitting = 'true';

        const button = form.querySelector('[data-add-to-cart-btn], button[type="submit"]');
        const originalText = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          button.textContent = 'ADDING...';
        }

        let added = false;
        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });

          if (!response.ok) {
            throw new Error('Could not add item to cart (HTTP ' + response.status + ')');
          }

          added = true;
          if (button) button.textContent = 'ADDED';

          // A refresh failure must NOT submit the form again, or it could
          // add a second item after the original request succeeded.
          try {
            const cart = await getCart();
            updateCartCount(cart);
            updateCartDrawerItems(cart);
            updateCartDrawerFooter(cart);
            openCartDrawer();
          } catch (refreshError) {
            console.error('Item added, but could not refresh cart drawer:', refreshError);
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          if (button) button.textContent = 'PLEASE TRY AGAIN';
          // Intentionally no form.submit() fallback. It could double-add.
        } finally {
          if (button) {
            // Restore the original ADD TO BAG / SOLD OUT button label.
            button.textContent = added ? (originalText || 'ADD TO BAG') : 'PLEASE TRY AGAIN';
            button.disabled = false;
          }
          form.dataset.cartSubmitting = 'false';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAjaxAddToCart);
  } else {
    initAjaxAddToCart();
  }
})();
/* SWAN MILANO - CART DRAWER QUANTITY FIX */
(function () {
  let ignoreCartMutation = false;
  let cartRefreshTimer = null;

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = '';
    });

    const drawerTitle = document.querySelector('.cart-drawer__title');
    if (drawerTitle) {
      drawerTitle.textContent = `Your Bag (${cart.item_count})`;
    }
  }

  function updateCartDrawerItems(cart) {
    const content = document.querySelector('[data-cart-drawer-content]');
    if (!content) return;

    ignoreCartMutation = true;

    if (cart.item_count === 0) {
      content.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      setTimeout(() => {
        ignoreCartMutation = false;
      }, 150);
      return;
    }

    content.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" class="cart-item__image">`
        : '';

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>`
        : '';

      const minusQuantity = Math.max(item.quantity - 1, 0);
      const plusQuantity = item.quantity + 1;

      return `
        <div class="cart-item">
          ${image}

          <div class="cart-item__info">
            <p class="cart-item__title">${escapeHtml(item.product_title)}</p>
            ${variant}

            <div class="cart-item__quantity" data-cart-quantity-row>
              <button
                type="button"
                class="cart-item__quantity-btn"
                data-cart-quantity-change
                data-line-key="${escapeHtml(item.key)}"
                data-quantity="${minusQuantity}"
                aria-label="Decrease quantity"
              >
                −
              </button>

              <span class="cart-item__quantity-value">
                ${item.quantity}
              </span>

              <button
                type="button"
                class="cart-item__quantity-btn"
                data-cart-quantity-change
                data-line-key="${escapeHtml(item.key)}"
                data-quantity="${plusQuantity}"
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>

            <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>

            <button
              type="button"
              class="cart-item__remove"
              data-cart-quantity-change
              data-line-key="${escapeHtml(item.key)}"
              data-quantity="0"
            >
              Remove all
            </button>
          </div>
        </div>
      `;
    }).join('');

    setTimeout(() => {
      ignoreCartMutation = false;
    }, 150);
  }

  function updateCartDrawerFooter(cart) {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    let footer = document.querySelector('[data-cart-drawer-footer]');

    if (cart.item_count === 0) {
      if (footer) footer.remove();
      return;
    }

    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-drawer__footer';
      footer.setAttribute('data-cart-drawer-footer', '');
      drawer.appendChild(footer);
    }

    footer.innerHTML = `
      <div class="cart-drawer__subtotal">
        <span>Subtotal</span>
        <span>${formatMoney(cart.total_price)}</span>
      </div>

      <a href="/checkout" class="cart-drawer__checkout">PROCEED TO CHECKOUT</a>
    `;
  }

  function renderCart(cart) {
    updateCartCount(cart);
    updateCartDrawerItems(cart);
    updateCartDrawerFooter(cart);
  }

  async function refreshCartDrawer() {
    const cart = await getCart();
    renderCart(cart);
  }

  async function changeCartQuantity(lineKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: Number(quantity)
      })
    });

    if (!response.ok) {
      throw new Error('Could not update cart quantity');
    }

    const cart = await response.json();
    renderCart(cart);
  }

  function initCartQuantityButtons() {
    document.addEventListener('click', async function (event) {
      const button = event.target.closest('[data-cart-quantity-change]');
      if (!button) return;

      event.preventDefault();

      const lineKey = button.dataset.lineKey;
      const quantity = button.dataset.quantity;

      if (!lineKey || quantity === undefined) return;

      button.disabled = true;

      try {
        await changeCartQuantity(lineKey, quantity);
      } catch (error) {
        console.error('Cart quantity update error:', error);
        await refreshCartDrawer();
      }
    });
  }

  function initCartDrawerObserver() {
    const content = document.querySelector('[data-cart-drawer-content]');
    if (!content) return;

    const observer = new MutationObserver(function () {
      if (ignoreCartMutation) return;

      clearTimeout(cartRefreshTimer);
      cartRefreshTimer = setTimeout(function () {
        refreshCartDrawer().catch(function (error) {
          console.error('Cart drawer refresh error:', error);
        });
      }, 100);
    });

    observer.observe(content, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    initCartQuantityButtons();
    initCartDrawerObserver();
    refreshCartDrawer().catch(function (error) {
      console.error('Initial cart drawer refresh error:', error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();